'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var SIZE_CLASSES = exports.SIZE_CLASSES = {
  auto: '',
  medium: 'private-modal--medium',
  short: 'private-modal--short',
  tall: 'private-modal--tall'
};

var MODAL_USE_CLASSES = exports.MODAL_USE_CLASSES = {
  default: 'private-modal--default private-modal--is-popup',
  conversational: 'private-modal--conversational private-modal--is-popup',
  info: 'private-modal--info private-modal--is-popup',
  success: 'private-modal--success private-modal--is-popup',
  danger: 'private-modal--danger private-modal--is-popup',
  fullscreen: 'private-modal--fullscreen',
  lightbox: 'private-modal--lightbox',
  upgrades: 'private-modal--upgrades private-modal--is-popup'
};

var DIALOG_USE_CLASSES = exports.DIALOG_USE_CLASSES = _extends({}, MODAL_USE_CLASSES, {
  sidebar: 'private-modal--sidebar'
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/dialog/DialogConstants.js
// module id = 122
// module chunks = 177